export default coord => `${coord * 100}%`



// WEBPACK FOOTER //
// ./client/modules/util/toPercent.js